<script>
import "@vueform/multiselect/themes/default.css";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";

import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import Axios from "@/config/axios";
import animationData from "@/components/widgets/msoeawqm.json";
import Lottie from "@/components/widgets/lottie.vue";

export default {
  page: {
    title: "Ramassages",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Frais de ramassages",
      items: [
        {
          text: "Enregistrer un colis",
          href: "/",
        },
        {
          text: "Frais de ramassages",
          active: true,
        },
      ],
      page: 1,
      perPage: 8,
      pages: [],
      value: null,
      statusquestion: "All",
      value1: null,
      searchQuery: null,
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "d M, Y",
        mode: "range",
      },
      timeConfig: {
        enableTime: false,
        dateFormat: "d M, Y",
      },
      date: null,
      date2: null,
      defaultOptions: {
        animationData: animationData,
      },
      pickupList: [],
      isStatus: null,
      isPayment: null,
      fields: {
        tag: "",
        code: "",
        label: "",
        prix_par_m3_neuf: "",
        prix_par_m3_occasion: "",
        prix_unitaire_neuf: "",
        prix_unitaire_occasion: "",
      },
    };
  },
  components: {
    Layout,
    PageHeader,
    lottie: Lottie,
  },
  created() {},
  filters: {
    trimWords(value) {
      return value.split(" ").splice(0, 20).join(" ") + "...";
    },
  },

  mounted() {},
  async beforeRouteEnter() {
    let pickupList = [];

    await Axios.get("/admin/pickup-sea-fees")
      .then(({ data }) => {
        pickupList = data.data;
      })
      .catch((er) => {
        console.log(er);
      });

    localStorage.setItem("@PICKUPS_LIST", JSON.stringify(pickupList));
  },
  beforeMount() {
    this.pickupList = JSON.parse(localStorage.getItem("@PICKUPS_LIST") || "[]");
  },
  methods: {
    formatPrice(price, currencyCode = "EUR") {
      try {
        const formatter = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currencyCode,
          minimumFractionDigits: 2,
        });
        return formatter.format(price);
      } catch (error) {
        // Handle any potential errors, e.g., if the browser doesn't support Intl.NumberFormat
        console.error("Error formatting price:", error);
        return price.toString(); // Return the unformatted price as a fallback
      }
    },
    async handleGetPickupList() {
      await Axios.get("/admin/pickup-sea-fees")
        .then(({ data }) => {
          this.pickupList = data.data;
        })
        .catch((er) => {
          console.log(er);
        });
    },
    editdata(data) {
      let result = this.pickupList.findIndex(
        (o) => o.pickupId == data.pickupId
      );
      document.getElementById("edtpickupId").value = this.pickupList[result].id;
      this.fields = { ...data };
    },
    handleUpdate() {
      document.getElementById("edtclosemodal").click();

      Axios.put(
        `/admin/pickup-sea-fees/${
          document.getElementById("edtpickupId").value
        }/update`,
        this.fields
      )
        .then(() => {
          this.handleGetPickupList();
        })
        .catch((er) => {
          console.log(er);
        });
    },
    handleCreate() {
      document.getElementById("createclosemodal").click();

      Axios.post(`/admin/pickup-sea-fees/create`, this.fields)
        .then(() => {
          this.handleGetPickupList();
          this.fields = {
            tag: "",
            code: "",
            label: "",
            prix_par_m3_neuf: "",
            prix_par_m3_occasion: "",
            prix_unitaire_neuf: "",
            prix_unitaire_occasion: "",
          };
        })
        .catch((er) => {
          console.log(er);
        });
    },
    deletedata(event) {
      Swal.fire({
        title: "Êtes-vous certain ?",
        text: "Cette opération est irréversible !",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: "Oui, supprimer !",
      }).then((result) => {
        if (result.value) {
          this.pickupList.splice(this.pickupList.indexOf(event), 1);
          Axios.delete(`/admin/pickup-sea-fees/${event.id}/delete`)
            .then(() => {
              this.handleGetPickupList();
            })
            .catch((er) => {
              console.log(er);
            });
          Swal.fire(
            "Supprimé !",
            "La nature de colis a été effacée.",
            "success"
          );
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="orderList">
          <div class="card-header border-0">
            <div class="d-flex align-items-center">
              <h5 class="card-title mb-0 flex-grow-1">Nature des colis</h5>
              <div class="flex-shrink-0">
                <button
                  type="button"
                  class="btn btn-success add-btn"
                  data-bs-toggle="modal"
                  id="create-btn"
                  data-bs-target="#showModal"
                >
                  <i class="ri-add-line align-bottom me-1"></i> Ajouter une
                  nature
                </button>
                <!-- <button type="button" class="btn btn-info ms-1">
                  <i class="ri-file-download-line align-bottom me-1"></i> Importer
                </button> -->
              </div>
            </div>
          </div>
          <div
            class="card-body pt-4 border border-dashed border-end-0 border-start-0"
          >
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                    <tr class="text-uppercase">
                      <th class="sort" data-sort="id">#</th>
                      <th class="sort" data-sort="customer_name">Nature</th>
                      <th class="sort text-center" data-sort="product_name">
                        Prix / m<sup>3</sup> neuf (€)
                      </th>
                      <th class="sort text-center" data-sort="product_name">
                        Prix / m<sup>3</sup> occasion (€)
                      </th>
                      <th class="sort text-center" data-sort="product_name">
                        Prix unitaire neuf (€)
                      </th>
                      <th class="sort text-center" data-sort="product_name">
                        Prix unitaire occasion (€)
                      </th>
                      <th class="sort" data-sort="city">Actions</th>
                    </tr>
                  </thead>
                  <tbody
                    class="list form-check-all"
                    v-for="(item, index) of pickupList"
                    :key="index"
                  >
                    <tr>
                      <td class="id">
                        {{ index + 1 }}
                      </td>
                      <td class="customer_name">
                        {{ item.tag }} - {{ item.label }}
                      </td>
                      <td class="customer_name text-center">
                        {{
                          item.prix_par_m3_neuf
                            ? formatPrice(item.prix_par_m3_neuf)
                            : "-"
                        }}
                      </td>
                      <td class="amount text-center">
                        {{
                          item.prix_par_m3_occasion
                            ? formatPrice(item.prix_par_m3_occasion)
                            : "-"
                        }}
                      </td>
                      <td class="amount text-center">
                        {{
                          item.prix_unitaire_neuf
                            ? formatPrice(item.prix_unitaire_neuf)
                            : "-"
                        }}
                      </td>
                      <td class="amount text-center">
                        {{
                          item.prix_unitaire_neuf
                            ? formatPrice(item.prix_unitaire_occasion)
                            : "-"
                        }}
                      </td>
                      <td>
                        <ul class="list-inline hstack gap-2 mb-0">
                          <li
                            class="list-inline-item edit"
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-placement="top"
                            title="Edit"
                          >
                            <a
                              class="text-primary d-inline-block edit-item-btn"
                              data-bs-toggle="modal"
                              href="#EditModal"
                              @click="editdata(item)"
                            >
                              <i class="ri-pencil-fill fs-16"></i>
                            </a>
                          </li>
                          <li
                            class="list-inline-item"
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-placement="top"
                            title="Remove"
                          >
                            <a
                              class="text-danger d-inline-block remove-item-btn"
                              @click="deletedata(item)"
                            >
                              <i class="ri-delete-bin-5-fill fs-16"></i>
                            </a>
                          </li>
                        </ul>
                      </td>
                      <!-- </div> -->
                    </tr>
                  </tbody>
                </table>
                <div class="noresult" style="display: none">
                  <div class="text-center">
                    <lottie
                      class="avatar-xl"
                      colors="primary:#121331,secondary:#08a88a"
                      :options="defaultOptions"
                      :height="75"
                      :width="75"
                    />
                    <h5 class="mt-2">Pardon! Aucun résultat trouvé</h5>
                    <p class="text-muted">
                      Nous avons recherché plus de 150 commandes Nous n'en avons
                      trouvé aucune commandes pour votre recherche.
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <div class="pagination-wrap hstack gap-2">
                  <a
                    class="page-item pagination-prev disabled"
                    href="#"
                    v-if="page != 1"
                    @click="page--"
                  >
                    Precedent
                  </a>
                  <ul class="pagination listjs-pagination mb-0">
                    <li
                      v-for="(pageNumber, index) in pages.slice(
                        page - 1,
                        page + 5
                      )"
                      :key="index"
                      @click="page = pageNumber"
                      :class="{
                        active: pageNumber == page,
                        disabled: pageNumber == '...',
                      }"
                    >
                      <a class="page" href="#">{{ pageNumber }}</a>
                    </li>
                  </ul>
                  <a
                    class="page-item pagination-next"
                    href="#"
                    @click="page++"
                    v-if="page < pages.length"
                  >
                    Suivant
                  </a>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="showModal"
              tabindex="-1"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-light p-3">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Ajouter une nature de colis
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-modal"
                    ></button>
                  </div>
                  <form action="#" id="createform">
                    <div class="modal-body">
                      <input type="hidden" id="id-field" />

                      <div class="mb-4">
                        <div class="row mb-3">
                          <div class="col-md-6 col-12">
                            <label for="tag">Groupe</label>
                            <input
                              type="text"
                              class="form-control"
                              id="tag"
                              placeholder="Groupe"
                              required
                              v-model="fields.tag"
                            />
                          </div>

                          <div class="col-md-6 col-12">
                            <label for="label">Libellé</label>
                            <input
                              type="text"
                              class="form-control"
                              id="label"
                              placeholder="Libellé"
                              required
                              v-model="fields.label"
                            />
                          </div>
                        </div>

                        <!-- prix_par_m3_neuf, prix_par_m3_occasion -->
                        <div class="row mb-3">
                          <div class="col-md-6 col-12">
                            <label for="prix_par_m3_neuf">Prix (€)</label>
                            <input
                              type="number"
                              class="form-control"
                              id="prix_par_m3_neuf"
                              placeholder="Prix par m3 (€)"
                              required
                              v-model="fields.prix_par_m3_neuf"
                            />
                          </div>

                          <div class="col-md-6 col-12">
                            <label for="prix_par_m3_occasion">
                              Prix par occasion (€)
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="prix_par_m3_occasion"
                              placeholder="Prix par occasion (€)"
                              required
                              v-model="fields.prix_par_m3_occasion"
                            />
                          </div>
                        </div>

                        <!-- prix_unitaire_neuf, prix_unitaire_occasion -->
                        <div class="row mb-3">
                          <div class="col-md-6 col-12">
                            <label for="prix_unitaire_neuf"
                              >Prix unitaire (€)</label
                            >
                            <input
                              type="number"
                              class="form-control"
                              id="prix_unitaire_neuf"
                              placeholder="Prix unitaire (€)"
                              required
                              v-model="fields.prix_unitaire_neuf"
                            />
                          </div>

                          <div class="col-md-6 col-12">
                            <label for="prix_unitaire_occasion">
                              Prix unitaire occasion (€)
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="prix_unitaire_occasion"
                              placeholder="Prix unitaire occasion (€)"
                              required
                              v-model="fields.prix_unitaire_occasion"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          class="btn btn-light"
                          data-bs-dismiss="modal"
                          id="createclosemodal"
                        >
                          Fermer
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          id="add-btn"
                          @click="handleCreate"
                        >
                          Enregistrer
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="EditModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabels"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-light p-3">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Editer un type de colis
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-modal"
                    ></button>
                  </div>
                  <form action="#" id="editform">
                    <div class="modal-body">
                      <input type="hidden" id="id-field" />

                      <div class="mb-3 d-none" id="modal-id">
                        <label for="pickupId" class="form-label">ID</label>
                        <input
                          type="text"
                          pattern="\d*"
                          id="edtpickupId"
                          class="form-control"
                          placeholder="ID"
                          maxlength="3"
                          readonly
                        />
                      </div>

                      <div class="mb-4">
                        <div class="row mb-3">
                          <div class="col-md-6 col-12">
                            <label for="tag">Groupe</label>
                            <input
                              type="text"
                              class="form-control"
                              id="tag"
                              placeholder="Groupe"
                              required
                              v-model="fields.tag"
                            />
                          </div>

                          <div class="col-md-6 col-12">
                            <label for="label">Libellé</label>
                            <input
                              type="text"
                              class="form-control"
                              id="label"
                              placeholder="Libellé"
                              required
                              v-model="fields.label"
                            />
                          </div>
                        </div>

                        <!-- prix_par_m3_neuf, prix_par_m3_occasion -->
                        <div class="row mb-3">
                          <div class="col-md-6 col-12">
                            <label for="prix_par_m3_neuf"
                              >Prix par m3 neuf (€)</label
                            >
                            <input
                              type="number"
                              class="form-control"
                              id="prix_par_m3_neuf"
                              placeholder="Prix par m3 (€)"
                              required
                              v-model="fields.prix_par_m3_neuf"
                            />
                          </div>

                          <div class="col-md-6 col-12">
                            <label for="prix_par_m3_occasion">
                              Prix par m3 occasion (€)
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="prix_par_m3_occasion"
                              placeholder="Prix par occasion (€)"
                              required
                              v-model="fields.prix_par_m3_occasion"
                            />
                          </div>
                        </div>

                        <!-- prix_unitaire_neuf, prix_unitaire_occasion -->
                        <div class="row mb-3">
                          <div class="col-md-6 col-12">
                            <label for="prix_unitaire_neuf"
                              >Prix unitaire neuf (€)</label
                            >
                            <input
                              type="number"
                              class="form-control"
                              id="prix_unitaire_neuf"
                              placeholder="Prix unitaire (€)"
                              required
                              v-model="fields.prix_unitaire_neuf"
                            />
                          </div>

                          <div class="col-md-6 col-12">
                            <label for="prix_unitaire_occasion">
                              Prix unitaire occasion (€)
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="prix_unitaire_occasion"
                              placeholder="Prix unitaire occasion (€)"
                              required
                              v-model="fields.prix_unitaire_occasion"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          class="btn btn-light"
                          data-bs-dismiss="modal"
                          id="edtclosemodal"
                        >
                          Fermer
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          id="add-btn"
                          @click="handleUpdate"
                        >
                          Modifier
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </Layout>
</template>
